__turbopack_context__.v({
  "image": "CardLeadership-module-scss-module__sMNUuq__image",
  "imageContainer": "CardLeadership-module-scss-module__sMNUuq__imageContainer",
  "leadership": "CardLeadership-module-scss-module__sMNUuq__leadership",
  "name": "CardLeadership-module-scss-module__sMNUuq__name",
  "position": "CardLeadership-module-scss-module__sMNUuq__position",
});
